module.exports = __webpack_public_path__ + "static/media/enrollment_admin_actions.2c23741e.svg";